import React from 'react'
import GridComp from '../Components/GridComp'
import l1 from '../assets/a1.webp'
import HeadingBlock from '../Components/HeadingBlock'
import IconCard from '../Components/Iconcard';
import { Scan, Satellite, Users } from "lucide-react";
import ListWithIcon from '../Components/ListWithIcon';
import ReusableBanner from '../Components/Banner';
import l5 from "../assets/b.webp";
import banner1 from '../assets/baneer1.webp'
import banner2 from '../assets/baneer2.webp'
function About() {
   const data2 = [
  { title: "Awareness & Access",desc:"Spread awareness about the scheme and provide clear onboarding pathways." },
  { title: "Income & Independence",desc:"Enable SHG women to build sustainable incomes through services." },
  { title: "Knowledge & Support",desc:"Provide training, workshops, and a strong support network." },
];
 const services = [
    {
      icon: <Scan className="w-8 h-8" />,
      title: "Advanced Drone Tech",
      description:
        "Cutting-edge UAVs, service & maintenance support.",
    },
    {
    icon: <Satellite className="w-8 h-8" />,
      title: "IoT-driven Precision Farming",
      description:
        "Smart insights to strengthen every harvest.",
    },
    {
       icon: <Users className="w-8 h-8" />,
      title: "Empowerment Network",
      description:
        "Training, certification, and community-led support.",
    },
  
  ];
  return (
    <>
    
<ReusableBanner
  bgImage={banner1}
  title={<span>Grow faster with <span className="text-green-400">Precision</span> tools</span>}
  subtitle="Smart farming techniques, data-driven decisions"
  height="h-[60vh] md:h-[70vh]"
  fixedAttachment={true}
  align="left"
  // cta={{ text: "Get started", href: "/signup" }}
/>
        <div className="inset-0 pt-10 bg-gradient-to-b from-emerald-50 via-white to-white">
            <div className='max-w-7xl p-4 mx-auto'>
                              <HeadingBlock
        subtitle="Creating women entrepreneurs through agri-tech innovation"
        title="A New Breed of Farmer: Meet the Drone Didi"
          align="left"

        // highlight="Agency"
      />
<GridComp
  title="Welcome to"
  highlight="Drone Didi"
  paragraphs={[
    "Where the future of farming takes flight—powered by the women who grow our nation.",
    "We’re honored to champion the Government of India’s revolutionary Namo Drone Didi Scheme. We are building a skybridge between cutting-edge technology and the heart of rural India.",
    "Imagine a field where innovation meets empowerment. Here, women from self-help groups are transforming into certified drone pilots, mastering the skies to nurture the land below. Drone Didi provides the wings for this transformation— a complete ecosystem of advanced drone technology, dedicated maintenance, and powerful data analytics that turns flight into insight.",
    "We are your collaborators in this revolution, integrating IoT-driven precision farming to strengthen every harvest, conserve every resource, and elevate every community. This is a journey of independence and leadership. We are here to ensure that every woman who steps into this role doesn’t just succeed; she soars, becoming a beacon of progress and a true Drone Didi."
  ]}
  image={l1}
  align="left"
  reverse={true}
  titleColor="text-green-950"         // Default = white
  highlightColor="text-orange-400" // Custom highlight color
/>

 <div className="grid md:grid-cols-3 my-8 gap-8">
        {services.map((service, index) => (
          <IconCard
            key={index}
            icon={service.icon}
              // iconPosition="top-right"
                iconPosition="top-center"
  cardBg="bg-[#ade7bb]"      // dark red
  iconBg="bg-[#ffbf68]"          // light blue
  // txtcolor="text-white"
  // iconPosition="top-left"

            title={service.title}
            description={service.description}
            borderGradient="from-yellow-200 to-green-600"
            // arrowIcon={<ArrowRight className="w-5 h-5 text-green-500" />}
          />
        ))}
      </div>

        </div>

    <section
  className="relative bg-fixed bg-center bg-cover py-20" 
  style={{ backgroundImage: `url(${banner2})` }}
>
  {/* Overlay */}
  <div className="absolute inset-0 bg-[#14532dd4]"></div>

  {/* Content */}
  <div className="relative z-10 max-w-7xl mx-auto px-4 text-white">
    <HeadingBlock
      subtitle="Our Goal"
      title="Inspire & Empower Rural"
      align="center"
      highlight="Women"
            subtitleColor="text-white"
      titleColor="text-white"
    />

    <p className="text-center max-w-3xl mx-auto mt-4 text-lg leading-relaxed">
      Introduce life-changing opportunities of the Namo Drone Didi Scheme— 
      and connect women with tools and knowledge to achieve independence, 
      income, and leadership.
    </p>

    {/* List with Icons */}
    <ListWithIcon
      items={data2}
      icon={Satellite}
      size="lg"
      layout="grid"
      iconColor="text-green-600"
      variant="soft"
      iconBg="bg-green-50"
      className="my-10"
      itemcolor="text-white"
    />

    {/* Extra block under Our Goal */}
    <div className="mt-16">
      <HeadingBlock
        subtitle="Our Dream"
        title="A Drone Didi in Every"
        align="center"
        highlight="Village"
         subtitleColor="text-white"
      titleColor="text-white"
      />
      <p className="text-center bg-green-900 text-white rounded-xl p-8 md:p-12 lg:px-[15%] mt-6 text-lg leading-relaxed shadow-lg">
        We imagine a future where every village has its own "Drone Didi"—
        someone who supports farmers with precision services, creates local jobs,
        and inspires the next generation of women leaders.
      </p>
    </div>
  </div>
</section>

              <div className="my-10 max-w-7xl mx-auto px-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        
        {/* Left Side : Heading + List */}
        <div>
          <HeadingBlock
            subtitle="Start Here"
            title="This platform is your gateway to"
            highlight="opportunities"
            align="left"
          />
       <ListWithIcon
  items={data2}
  icon={Satellite}
  size="lg"
  layout="verticle"
  variant="solid"
  iconBg="bg-green-900"
  className="my-6"
  itemcolor="text-black"
/>
        </div>

        {/* Right Side : Image */}
        <div className="flex justify-center">
          <img
            src={l5}
            alt="illustration"
            className="w-full h-auto max-w-md object-contain"
          />
        </div>
      </div>
    </div>
       
</div>

    </>
  )
}

export default About